import { Box, Paper, Typography } from "@mui/material";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import FavoriteBorderOutlinedIcon from "@mui/icons-material/FavoriteBorderOutlined";
import MedicalServicesOutlinedIcon from "@mui/icons-material/MedicalServicesOutlined";
import BiotechOutlinedIcon from "@mui/icons-material/BiotechOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";

const ACCENT = "#FF8904";

const audiences = [
  {
    icon: <PsychologyOutlinedIcon sx={{ fontSize: 28, color: ACCENT }} />,
    title: "Neurologistas",
    description: "Epilepsia refratária, esclerose múltipla, dor neuropática",
  },
  {
    icon: <FavoriteBorderOutlinedIcon sx={{ fontSize: 28, color: ACCENT }} />,
    title: "Psiquiatras",
    description: "Ansiedade, TEPT, transtornos do sono e TEA",
  },
  {
    icon: <MedicalServicesOutlinedIcon sx={{ fontSize: 28, color: ACCENT }} />,
    title: "Clínicos Gerais",
    description: "Dor crônica, síndrome de fadiga, fibromialgia",
  },
  {
    icon: <BiotechOutlinedIcon sx={{ fontSize: 28, color: ACCENT }} />,
    title: "Oncologistas",
    description: "Náuseas quimioterápicas, dor oncológica, caquexia",
  },
  {
    icon: <GroupsOutlinedIcon sx={{ fontSize: 28, color: ACCENT }} />,
    title: "Outros Prescritores",
    description: "Dentistas, reumatologistas e geriatras",
  },
];

export default function TargetAudienceSection() {
  return (
    <section className="relative z-10 px-6 md:px-12 pb-20 md:pb-28">
      <div className="text-center mb-14">
        <Typography
          sx={{
            color: ACCENT,
            fontWeight: 700,
            fontSize: "0.8rem",
            letterSpacing: "0.15em",
            marginBottom: "12px",
          }}
        >
          PÚBLICO-ALVO
        </Typography>
        <Typography
          variant="h4"
          sx={{
            color: "#ffffff",
            fontWeight: 700,
            fontFamily: "Oxanium, sans-serif",
            letterSpacing: "-0.02em",
            marginBottom: "12px",
            fontSize: { xs: "1.5rem", md: "2rem" },
          }}
        >
          Para quem foi criado
        </Typography>
        <Typography
          sx={{
            color: "rgba(255,255,255,0.6)",
            fontSize: "1.05rem",
            maxWidth: "550px",
            margin: "0 auto",
          }}
        >
          Desenvolvido exclusivamente para profissionais legalmente habilitados a prescrever cannabis medicinal.
        </Typography>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-6 max-w-6xl mx-auto">
        {audiences.map((audience) => (
          <Paper
            key={audience.title}
            elevation={0}
            sx={{
              background:
                "linear-gradient(135deg, rgba(26, 49, 60, 0.6) 0%, rgba(4, 9, 10, 0.8) 100%)",
              backdropFilter: "blur(16px)",
              border: "1px solid rgba(255,255,255,0.08)",
              borderRadius: "24px",
              padding: "24px",
              textAlign: "center",
              transition: "all 0.3s ease",
              "&:hover": {
                border: "1px solid rgba(255, 137, 4, 0.3)",
                transform: "translateY(-4px)",
                boxShadow: "0 12px 40px rgba(0,0,0,0.3)",
              },
            }}
          >
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: "16px",
                background: "rgba(255, 137, 4, 0.12)",
                border: "1px solid rgba(255, 137, 4, 0.25)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
              }}
            >
              {audience.icon}
            </Box>
            <Typography
              sx={{
                color: "#ffffff",
                fontWeight: 700,
                fontSize: "1rem",
                fontFamily: "Oxanium, sans-serif",
                marginBottom: "8px",
              }}
            >
              {audience.title}
            </Typography>
            <Typography
              sx={{
                color: "rgba(255,255,255,0.6)",
                fontSize: "0.875rem",
                lineHeight: 1.6,
              }}
            >
              {audience.description}
            </Typography>
          </Paper>
        ))}
      </div>
    </section>
  );
}
